const state = {
  detail_transaction: [],
};

export default state;
